module.exports = __webpack_public_path__ + "static/media/a69f87b3-ff48-44dc-9708-7e4e46de1b74.9cc5684b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/competence/a69f87b3-ff48-44dc-9708-7e4e46de1b74.png
// module id = 1462
// module chunks = 0